import React from 'react';
import { View } from 'react-native';
import { scale } from '../../Styles';

import { StudentsUploadProps } from '../containers/StudentsUploadContainer';
import { MNOHSButton } from '../MNOHSButton';
import { MNOHSDashboardWrapper } from '../MNOHSDashboardWrapper';
import { MNOHSUploadField } from '../MNOHSUploadField';

export const StudentsUploadScreen: React.FC<StudentsUploadProps> = ({
  files,
  buttonState,
  userChoseDocument,
  userClickedProcess,
}) => {
  return (
    <MNOHSDashboardWrapper
      headerTitle={'Upload Students'}
      padded={true}
      parentComponentType={'View'}
      childContainerStyle={{ justifyContent: 'space-between' }}>
      {/* This View component anchors the fields to the top */}
      <View>
        <MNOHSUploadField
          title={'Add Students'}
          value={files.students?.type === 'success' ? files.students.name : ''}
          onPress={userChoseDocument}
        />
      </View>

      {/* for some reason, if you separate the style, it doesn't work */}
      <MNOHSButton style={styles.button} state={buttonState} title={'PROCESS'} onPress={userClickedProcess} />
    </MNOHSDashboardWrapper>
  );
};

const styles = {
  button: {
    marginTop: scale(20),
    marginBottom: scale(60),
  },
};
